import Vue from 'vue';
import Vuex from 'vuex';

import {HTTP} from '../http-common';
import EventBus from "../components/event-bus";

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        role: 0,
        user_time_zone: 'UTC',
    },
    mutations: {
        changeUserRole(state, role) {
            state.role = role;
        },
        changeUserTimeZone(state, user_time_zone) {
            state.user_time_zone = user_time_zone;
        },
    },
    actions: {
        getRole: function(context) {
            var config = {
                headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
            };

            HTTP.get('user/role', config)
                .then(function (response) {
                    if (response.data.code == 200) {
                        context.role = response.data.content.roles[0].id;
                        context.commit('changeUserRole', context.role);
                        //self.permissions = response.data.content.permissions;
                        EventBus.$emit("reload-menu");
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    if (err.response.status == 0) {
                        self.error = "Remote server can not be reachable";
                    } else {

                    }
                });
        },
        getUserTimeZone: function(context) {
            var config = {
                headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
            };

            HTTP.get('user/time_zone', config)
                .then(function (response) {
                    if (response.data.code == 200) {
                        context.user_time_zone = response.data.content
                        context.commit('changeUserTimeZone', context.user_time_zone);
                        //self.permissions = response.data.content.permissions;
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    if (err.response.status == 0) {
                        self.error = "Remote server can not be reachable";
                    } else {

                    }
                });
        }
    },
    getters: {
        role: state => state.role,
        user_time_zone: state => state.user_time_zone,
    }
});


// WEBPACK FOOTER //
// ./src/store/store.js